import React from 'react';
import { Text, View } from 'react-native';
import { t } from 'Locale';
// eslint-disable-next-line import/no-unresolved
import { Button, Hr, Icon } from 'LocalGluons';

import defaultStyles from './SuspendErrorScene.jss';

interface SuspendErrorSceneProps {
    navigation: any; // TODO: FIX ME CompositeNavigationProp;
}

const SuspendErrorScene = ({ navigation }: SuspendErrorSceneProps): React.ReactElement => {
    const close = () => navigation.pop();

    return (
        <View style={defaultStyles.container}>
            <View style={defaultStyles.closeIconContainer}>
                <Icon style={defaultStyles.closeIcon} name="close" onPress={close} />
            </View>
            <View style={defaultStyles.headlineContainer}>
                <Icon style={defaultStyles.itemIcon} name="warning_yellow" />
                <Text style={defaultStyles.title}>{t('COMMON.SUSPENDED_ACCOUNT_TITLE')}</Text>
            </View>
            <Hr style={defaultStyles.hrStyle} />
            <Text style={defaultStyles.subtitle}>
                {t('COMMON.SUSPENDED_ACCOUNT_DESCRIPTION').split('.').join('.\n\n')}
            </Text>
            <View style={defaultStyles.buttonContainer}>
                <Button
                    style={{ button: defaultStyles.button }}
                    title={t('PARTNER.VOYO.OK_UNDERSTAND_BTN')}
                    onPress={close}
                />
            </View>
        </View>
    );
};

export default SuspendErrorScene;
